export default "__VITE_ASSET__t70prTw6q$NRQ55cjpIuqg__";